import { Model, Attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

@Model()
export default class Airline extends ApplicationRecord {
  static jsonapiType = 'airlines';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Name',
        value: 'name',
      },
    ];
  }

  static scopeFactory() {
    return Airline.includes([]);
  }

  @Attr() name: string;
}
